import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { store as appMainStore } from '@edf-pkg/app-main';

import useErrorHandler from '$app-web/hooks/use-error-handler';

import { useReadChatRooms } from './use-read-chat-rooms';

const useStudyUsersForChat = (studyId: number) => {
    const { mutateAsync: loadStudyResearchers } = useReadChatRooms(studyId);

    const { handleError } = useErrorHandler();
    const currentUserFullName = useSelector(appMainStore.userDuck.duckSelectors.fullNameSelector);
    const currentUserAvatarUrl = useSelector(appMainStore.userDuck.duckSelectors.avatarSelector);
    const currentUserId = useSelector(appMainStore.userDuck.duckSelectors.idSelector);

    return useCallback(async () => {
        try {
            const data = await loadStudyResearchers();

            return {
                ...data,
                [currentUserId]: {
                    id: currentUserId,
                    label: currentUserFullName,
                    avatarUrl: currentUserAvatarUrl,
                    role: 'participant',
                },
            };
        } catch (error) {
            handleError(error);
        }

        return {};
    }, [handleError, currentUserAvatarUrl, currentUserFullName, currentUserId, loadStudyResearchers]);
};

export default useStudyUsersForChat;
